var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 15,
    viewBox: "0 0 265 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.28624C54.7716 2.28624 108.543 2.28624 162.315 2.28624C191.925 2.28624 221.543 4.85403 251.119 2.28624C310.154 -2.83913 133.034 8.82838 73.9891 11.5054C64.861 11.9193 55.739 12.0477 46.6115 12.0477C43.5475 12.0477 47.968 12.0477 48.5785 12.0477C61.6559 12.0477 74.7333 12.0477 87.8108 12.0477C95.3595 12.0477 102.908 12.0477 110.457 12.0477C112.475 12.0477 114.947 10.2536 116.783 14",
    stroke: "#FEED00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.a2eb622cbe93f62c201bab45493345e3.svg";
export { ForwardRef as ReactComponent };